import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "left-panel" }
const _hoisted_3 = { class: "right-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageGallery = _resolveComponent("ImageGallery")!
  const _component_ProfileInfo = _resolveComponent("ProfileInfo")!
  const _component_DebugPanel = _resolveComponent("DebugPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ImageGallery)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ProfileInfo)
    ]),
    (_ctx.isDev)
      ? (_openBlock(), _createBlock(_component_DebugPanel, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}